import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
// Custom components
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { salesReports,salesExcel } from '../../../redux/actions/Report.action';
import { IoSearchOutline } from 'react-icons/io5';
import { Button, Modal } from 'react-bootstrap';
import { viewSaleBill } from '../../../redux/actions/Billing.action';
import { VscTarget } from 'react-icons/vsc';
import * as XLSX from 'xlsx';
import ReactPaginate from 'react-paginate';

export default function SalesReport() {
  const dispatch = useDispatch();
  const reportData = useSelector((state) => state.report);
  console.log("reportData",reportData);
  const billData = useSelector((state) => state.bills);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const limits = {
    page: currentPage,
    limit: itemsPerPage
  }
  const [reportModal, setReportModal] = useState(false);
  const reportToggle = () => {
    setReportModal(!reportModal);
  };

  const [formData, setFormData] = useState({
    date: '',
    startDate: '',
    endDate: '',
    type: '',
    paymentType: '',
    search: '',
  });

  const handleFormData = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
      ...(name === 'startDate' || name === 'endDate' ? { date: '' } : {}),
      ...(name === 'date' ? { startDate: '', endDate: '' } : {}),
    }));
  };
  const handleView = (pId) => {
    dispatch(viewSaleBill(pId));
  };

  useEffect(() => {
    let payload = {};
    if (formData.date) {
      payload.date = formData.date;
    } else {
      payload.date = '';
    }

    if (formData.startDate || formData.endDate) {
      payload.startDate = formData.startDate;
      payload.endDate = formData.endDate;
    } else {
      payload.startDate = '';
      payload.endDate = '';
    }

    if (formData) {
      payload.page = currentPage;
      payload.limit = itemsPerPage;
      payload.search = formData.search;
      dispatch(salesReports(payload, limits));
      dispatch(salesExcel(payload));
    }

  }, [formData, currentPage, itemsPerPage]);

  const filteredData = reportData?.salesReport?.data?.data || [];
  const totalCount = reportData?.salesReport?.data?.totalCount || 0;
  const totalPages = Math.ceil(totalCount / itemsPerPage);



  useEffect(() => {
    setCurrentPage(1);
  }, [formData.search]);

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected + 1); // ReactPaginate starts from 0
  };


  const handleDownload = () => {
    if (!reportData?.salesExcel?.data?.data || reportData?.salesExcel?.data?.data.length === 0) {
      alert('No data available to download!');
      return;
    }
  
    const exportData = reportData.salesExcel.data.data.map((invoice) => ({
      'Invoice No': invoice.invoiceNo,
      'Patient Name': invoice.patientName,
      'Phone Number': invoice.phoneNumber,
      City: invoice.city,
      'Invoice Date': new Date(invoice.invoiceDate).toLocaleDateString('en-GB'),
      Inhouse: invoice.inHouse,
      SGST: invoice.sgst,
      CGST: invoice.cgst,
      'Discount Amount': invoice.discountAmount || '-',
      'Discount (%)': invoice.cDiscount || '-',
      Charges: invoice.charges || '-',
      'Bill Amount': invoice.billAmount,
      'User': invoice?.billAddedBy,
      Remark: invoice.remark || '',
    }));
  
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sales Report');
  
    XLSX.writeFile(workbook, `Sales_Report.xlsx`);
  };
  
  

  return (
    <>
      <div className="mt-[100px]">
        <div className="d-flex items-center gap-3">
          <div className="w-[200px]">
            <label className="text-sm block mb-1">Date</label>
            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleFormData}
              className="w-75 outline-none !border-b"
            />
          </div>
          <div className="w-[200px]">
            <label className="text-sm block mb-1">Start Date</label>
            <input
              type="date"
              name="startDate"
              value={formData.startDate}
              onChange={handleFormData}
              className="w-75 outline-none !border-b"
            />
          </div>
          <div className="w-[200px]">
            <label className="text-sm block mb-1">End Date</label>
            <input
              type="date"
              name="endDate"
              value={formData.endDate}
              onChange={handleFormData}
              className="w-75 outline-none !border-b"
            />
          </div>
          <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center gap-2 me-2 ms-auto">
            <IoSearchOutline />
            <input
              type="text"
              name="search"
              value={formData.search}
              onChange={handleFormData}
              className="w-full outline-none"
              placeholder="Search..."
            />
          </div>
          <div>
            <Button
              onClick={handleDownload}
              className="px-4 !bg-theme-dark border-0 text-white"
            >
              Download
            </Button>
          </div>
        </div>

        <div className="col-6 text-end ms-auto mt-4">
          <div className="flex justify-end gap-3 font-medium text-lg">
            <label className="text-center block text-success border-r pe-3">
              <span>Sales Amount : </span>{' '}
              <span className="ms-1 border-b border-success">
                {reportData?.salesReport?.data?.totalPurchaseAmount?.toFixed(2)}
              </span>
            </label>
            <div className="">
              Total Records:{' '}
              <span className="text-success border-b border-success">
                {reportData?.salesReport?.data?.totalCount || 0}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-[50px] mb-4">
        <TableContainer>
          <Table variant="striped" colorScheme="blackAlpha">
            <Thead>
              <Tr>
                <Th>Invoice Date</Th>
                <Th>Patient Name</Th>
                <Th>Phone Number</Th>
                <Th>Invoice No.</Th>
                <Th>City</Th>
                <Th>Inhouse</Th>
                <Th>Gross Amount</Th>
                <Th>SGST</Th>
                <Th>CGST</Th>
                <Th>Discount Amount </Th>
                <Th>Discount (%)</Th>
                <Th>Charges</Th>
                <Th>Bill Amount</Th>
                <Th>User</Th>
                <Th>Remark</Th>
                <Th className="text-end sticky right-0 bg-white">Action</Th>
              </Tr>
            </Thead>
            <Tbody>
              {filteredData?.length > 0 ? (
                filteredData?.map((res, index) => {
                  return (
                    <Tr key={index}>
                      <Td>
                        {' '}
                        {new Date(res.invoiceDate).toLocaleDateString('en-GB', {
                          day: '2-digit',
                          month: '2-digit',
                          year: 'numeric',
                        })}
                      </Td>
                      <Td className='capitalize'>{res.patientName}</Td>
                      <Td>{res.phoneNumber}</Td>
                      <Td>{res.invoiceNo}</Td>
                      <Td className='capitalize'>{res.city}</Td>
                      <Td>{res.inHouse}</Td>
                      <Td>{res.grossAmount}</Td>
                      <Td>{res.sgst}</Td>
                      <Td>{res.cgst}</Td>
                      <Td>{res.discountAmount || '-'}</Td>
                      <Td>{res.cDiscount || '-'}</Td>
                      <Td>{res.charges || '-'}</Td>
                      <Td>{res.billAmount}</Td>
                      <Td>{res?.billAddedBy}</Td>
                      <Td className='capitalize'>{res.remark}</Td>
                      <Td
                        style={{
                          minWidth: '100px',
                          position: 'sticky',
                          right: '0',
                          backgroundColor: 'white',
                        }}
                      >
                        <div className="d-flex gap-3 justify-center">
                          <VscTarget
                            onClick={() => {
                              reportToggle();
                              handleView(res._id);
                            }}
                            className="cursor-pointer text-primary fs-5"
                          />
                        </div>
                      </Td>
                    </Tr>
                  );
                })
              ) : (
                <Tr>
                  <Td colSpan={29} textAlign={'center'}>
                    No any report
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </TableContainer>
      </div>
      {filteredData?.length > 0 && (
        <>
          <ReactPaginate
            breakLabel="..."
            nextLabel="next >"
            onPageChange={handlePageChange}
            pageRangeDisplayed={10}
            pageCount={totalPages}
            previousLabel="< previous"
            renderOnZeroPageCount={null}
            className="pagination"
            forcePage={currentPage - 1}
          />
        </>
      )}

      <Modal show={reportModal} onHide={reportToggle} centered size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Product Report</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-5">
          <div className="table-responsive">
            <table className="table table-bordered p-0">
              <thead>
                <tr className="text-center text-sm">
                  <th className="min-w-[300px]">Product Name</th>
                  <th className="!min-w-[100px]">HSN Code</th>
                  <th className="!min-w-[100px]">Pack</th>
                  <th className="!min-w-[100px]">MRP</th>
                  <th className="!min-w-[100px]">Batch</th>
                  <th className="!min-w-[100px]">Expire Date</th>
                  <th className="!min-w-[100px]">CD (%)</th>
                  <th className="!min-w-[100px]">Rate</th>
                  <th className="!min-w-[100px]">Qty</th>
                  <th className="!min-w-[100px]">Amount</th>
                  <th className="!min-w-[100px]">GST (%)</th>
                  <th className="!min-w-[100px]">Total Amount</th>
                </tr>
              </thead>
              <tbody>
                {billData?.viewSaleBill?.data?.data?.productList?.length > 0 ? (
                  billData?.viewSaleBill?.data?.data?.productList?.map(
                    (res) => {
                      return (
                        <tr>
                          <td className="uppercase">{res.productName}</td>
                          <td className="uppercase">{res.hsnCode}</td>
                          <td className="uppercase">{res.pack}</td>
                          <td>{res.mrp}</td>
                          <td className="uppercase">{res.batchNo}</td>
                          <td>
                            {new Date(res.expDate).toLocaleDateString('en-GB', {
                              day: '2-digit',
                              month: '2-digit',
                              year: 'numeric',
                            })}
                          </td>
                          <td>{res.discount}</td>
                          <td>{res.rate}</td>
                          <td>{res.qty}</td>
                          <td>{res.amount}</td>
                          <td>{res.gst}</td>
                          <td>{res.totalAmount}</td>
                        </tr>
                      );
                    },
                  )
                ) : (
                  <tr>
                    <td colSpan={14}>No any data</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button
            variant="secondary"
            onClick={reportToggle}
            className="px-4 bg-transparent border-[1px] text-black border-green-color"
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
